import { render, staticRenderFns } from "./BatchInquiryList.vue?vue&type=template&id=1726cc68"
import script from "./BatchInquiryList.vue?vue&type=script&lang=js"
export * from "./BatchInquiryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports